export type ClienteTextSearchFilters = {
  SearchCNPJ: string
  SearchRazaoSocial: string
  SearchNomeFantasia: string
  SearchLoginCliente: string
}

export function buildClienteTextSearchFiltersFromTerm(
  searchTerm: string | null
): ClienteTextSearchFilters {
  const raw = (searchTerm ?? '').trim()
  if (!raw) {
    return {
      SearchCNPJ: '',
      SearchRazaoSocial: '',
      SearchNomeFantasia: '',
      SearchLoginCliente: ''
    }
  }

  const alfanumericOnly = raw.replace(/[^0-9a-zA-Z]/g, '')
  
  const isCnpjPattern = /^[0-9a-zA-Z]{2}\.?[0-9a-zA-Z]{3}\.?[0-9a-zA-Z]{3}\/?[0-9a-zA-Z]{4}-?[0-9a-zA-Z]{2}$/i.test(raw)
  const isNumericOnly = /^\d+$/.test(alfanumericOnly)

  if (isCnpjPattern || (alfanumericOnly.length === 14) || (isNumericOnly && alfanumericOnly.length > 0 && alfanumericOnly.length <= 14)) {
    return {
      SearchCNPJ: raw,
      SearchRazaoSocial: '',
      SearchNomeFantasia: '',
      SearchLoginCliente: ''
    }
  }

  return {
    SearchCNPJ: '',
    SearchRazaoSocial: raw,
    SearchNomeFantasia: raw,
    SearchLoginCliente: raw
  }
}
